import React, { Fragment } from 'react';
import { CardBody, Card } from 'reactstrap';
import {
    Separator
} from '../../../../../../components/common/CustomBootstrap';

export default function Example({ url }) {
    return (
        <Card>
            <CardBody>
                <div className="text-center">
                    <h6> Example </h6>
                    <Separator className="mb-3" />
                    <img
                        src={url}
                        alt="example"
                        width="auto"
                        className="img-thumbnail"
                    />
                </div>
            </CardBody>
        </Card>

    );
}
